<template>
    <div class="pay-situation-container">
        <!-- 年份选择 -->
        <div class="year-picker-select">
            <mobile-button color="#808080" @click="selectYear">
                <span class="flex-select">
                    <span>{{yearText}}</span>
                    <van-icon name="arrow-down"/>
                </span>
            </mobile-button>
        </div>
        <div class="content">
            <div class="card-wrapper" v-for="(item, index) in list" :key="index">
                <mobile-card :show-title="false" :show-footer="true">
                    <template slot="content">
                        <div class="flex-form-info">
                            <span>收费项目</span>
                            <span>{{item.itemName}}</span>
                        </div>

                        <div class="flex-form-info">
                            <span>交费区间</span>
                            <span>{{item.intervalName}}</span>
                        </div>

                        <div class="flex-form-info">
                            <span>应交</span>
                            <span class="money-item">{{item.needPay | formatMoney}}</span>
                        </div>

                        <div class="flex-form-info">
                            <span>缓交</span>
                            <span>{{item.laterPay | formatMoney}}</span>
                        </div>

                        <div class="flex-form-info">
                            <span>实交</span>
                            <span class="money-item">{{item.realPay | formatMoney}}</span>
                        </div>
                    </template>

                    <template slot="footer">
                        <div class="flex-form-footer">
                            <div class="flex-form-btn" @click="checkDetail(item)">
                                <van-icon name="eye-o"/>
                                <span>查看详情</span>
                            </div>

                            <div class="flex-form-btn" @click="download(item)" v-if="item.ticketed">
                                <van-icon name="down"/>
                                <span>下载发票</span>
                            </div>
                        </div>
                    </template>

                </mobile-card>
            </div>
			<div v-if="$utils.isEmpty(list)" class="empty-block">
				<span>{{ emptyText }}</span>
			</div>
        </div>

        <van-popup v-model="showYearPicker" position="bottom">
            <van-picker
				show-toolbar
				title="选择年份"
				:columns="yearColumns"
				:default-index="defaultIndex"
				@cancel="showYearPicker = false"
				@confirm="onConfirm"
            ></van-picker>
        </van-popup>
    </div>
</template>

<script>
    import log from "utils/log"
    import MobileCard from "components/mobile-card/index";
    import apiPaySituation from "api/pay-situation";
    import moment from "moment"
	// import {setState} from "utils/state";
	import storage from 'good-storage'
	import MobileButton from "components/mobile-button/index";
	const defaultYear = moment().year()

    export default {
        components: {MobileButton, MobileCard},
        data() {
            return {
                // year: null,
				// yearText: null,
				defaultIndex:0,
                year:null,
                yearText:'全部',
                list: [],
                yearColumns: [],
				showYearPicker: false,
				emptyText:'暂无数据'
            }
		},

		created() {
			 this.getColumns()
		},
		
        activated() {
			console.log('activated---------')
            this.getList()
            // this.getColumns()
		},
		
        methods: {
            getList() {
                let self = this
                let param = {
                    year: self.year,
				}
				// this.getYearTextByYear(this.year)
                self.list = []
				apiPaySituation.list(param).then(res => {
                    log('res is ', res.data)
                    self.list = res.data || []
                })
			},

			getYear(year) {
				console.log(year)
				let yearColumns = this.yearColumns || []
				console.log(yearColumns)
				if(year === null) {
					this.defaultIndex = 0
					this.yearText = '全部'
				} else if( year === -1) {
					this.defaultIndex = 1
					this.yearText = '无区间年度'
				} else {
					yearColumns.forEach((item,index) => {
						if(item === year) {
							this.defaultIndex = index
							this.yearText = item
						}
					})
				}
			},
			
            onConfirm(value, index) {
				log('value', value, index)
				this.showYearPicker = false
				this.defaultIndex = index
                this.yearText = value
                let v = Number(value)
                if (!Number.isNaN(v)) {
                    this.year = v
                } else if (value === '全部') {
                    this.year = null
                } else {
                    this.year = -1
                }
                this.getList()
			},
			
			
            getColumns() {
                let now = moment()
				let y = now.year() + 1
                this.yearColumns = ['全部', '无区间年度']
                for (let index = 0; index < 6; index++) {
                    this.yearColumns.push(y - index)
				}
				this.year = defaultYear
				this.yearText = defaultYear
				this.defaultIndex = 3
			},
			
            selectYear() {
                this.showYearPicker = true
			},
			
            download(item) {
                log('item is', item)
                // setState('pay-item', item)
                storage.session.set('pay-item', item)
                this.$router.push({
                    path: 'pay-situation-download'
                })
			},
			
            checkDetail(item) {
                log('item is', item)
                // setState('pay-item', item)
                storage.session.set('pay-item', item)
                this.$router.push({
                    path: 'pay-situation-detail'
                })
            },

		},
    }
</script>

<style lang='scss' scoped>
</style>
